import './App.css';
// import ContactPage from "./pages/ContactPage";
// import Gallery from "./pages/Gallery";
// import HeroSection from  "./components/HeroSection";
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";
// import AboutSection from "./components/AboutSection";
// import Testimonials from "./components/Testimonials";
// import ServiceCard from "./components/ServiceCard";
// import ServiceList from "./components/ServiceList";
// import ContactForm from "./components/ContactForm";
// import ShopPage from "./pages/ShopPage";
// import ProductDetails from "./pages/ProductDetails";
// import Team from "./components/Team";
// import Faq from "./components/Faq";
// import Cta from "./components/Cta";
// import Recruit from "./components/Recruit";
// import CategoryPage from "./pages/CategoryPage";
//import AboutPage from "./pages/AboutPage";
import {Routes,Route} from 'react-router-dom';
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import NotFound from "./pages/NotFound";


function App(){
  return(
    <Routes>
        {/* Main Routes */}
        <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<NotFound />} />
            {/* <Route path="/about" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/products" element={<ShopPage />} />
            <Route path="/product/:productId" element={<ProductDetails />} />
            <Route path="/products/:occasion" element={<CategoryPage />} /> */}
        </Route>

        {/* Component Routes */}
        {/* <Route path="/hero-section" element={<HeroSection />} />
        <Route path="/about-section" element={<AboutSection />} />
        <Route path="/contact-form" element={<ContactForm />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/navbar" element={<Navbar />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/service-list"  element={<ServiceList />} />
        <Route path="/service-card" element={<ServiceCard />} />
        <Route path="/team" element={<Team />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/recruit" element={<Recruit />} />
        <Route path="/booking-cta" element={<Cta />} /> */}
        <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
